let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("d6j4K")).then(() => parcelRequire('6MNnt'));